import React from 'react'
import {
    UilArrowUp,
    UilArrowDown,
    UilTemperature,
    UilTear,
    UilWind,
    UilSun,
    UilSunset
} from "@iconscout/react-unicons"
import { formatToLocalTime } from '../services/weatherAPI'

export default function TemperatureAndDetails({
    weather: {details, icon, temp, temp_min, temp_max, sunrise, 
        sunset, speed, humidity, feels_like, timezone}
    }) {
    const iconUrlFromCode = `http://openweathermap.org/img/wn/${icon}@2x.png`
    
  return (
    <div>
        <div className='mx-auto text-center py-2 text-xl text-cyan-300'>
            <div className='mx-auto flex justify-center'>
                <img src={iconUrlFromCode} alt="weather" className='object-cover w-[120px] h-[120px]' />
            </div>
            <p>
                 {details}
            </p>
        </div>
        <div className='flex flex-row justify-center space-x-10 items-center text-center text-white py-3'>
            <img src={iconUrlFromCode} alt="weather" className='w-20' />
            <p className='text-5xl pb-5'>{`${temp.toFixed()}°C`}</p>
            <div className='flex flex-col space-y-2'>
                <div className='flex font-light text-sm items-center justify-center'>
                    <UilTemperature size={18} className='mr-1'/>
                    Real Fell:
                    <span className='font-medium ml-1'>{`${feels_like.toFixed()}°C`}</span>
                </div>
                <div className='flex font-light text-sm items-center justify-center'>
                    <UilTear size={18} className='mr-1'/>
                    Humidity:
                    <span className='font-medium ml-1'>{`${humidity}%`}</span>
                </div>
                <div className='flex font-light text-sm items-center justify-center'>
                    <UilWind size={18} className='mr-1'/>
                    Wind:
                    <span className='font-medium ml-1'>{`${speed.toFixed()} km/h`} </span>
                </div>
            </div>
        </div>

        <div className='text-gray-800 flex flex-row items-center justify-center space-x-2  text-sm py-3'>
          <div className='w-32 text-center bg-white bg-opacity-50 p-2 rounded-md'>
            <UilSun size={30} className='text-center mx-auto'/>
            <p>
                Rise: <span className='font-medium ml-1'>{formatToLocalTime(sunrise,timezone, 'hh:mm a')}</span>
            </p> 
          </div>
          <div className='w-32 text-center bg-white bg-opacity-50 p-2 rounded-md'>
            <UilSunset size={30} className='text-center mx-auto' />
            <p >
                Set: <span className='font-medium ml-1'>{formatToLocalTime(sunset,timezone, 'hh:mm a')}</span>
            </p> 
          </div>
          <div  className='w-32 text-center bg-white bg-opacity-50 p-2 rounded-md'>
            <UilArrowUp  size={30} className='text-center mx-auto'/>
            <p >
                High: <span className='font-medium ml-1'>{`${temp_max.toFixed()}°`}</span>
            </p>

          </div> 
          <div className='w-32 text-center bg-white bg-opacity-50 p-2 rounded-md'>
            <UilArrowDown size={30} className='text-center mx-auto' />
            <p >
                Low: <span className='font-medium ml-1'>{`${temp_min.toFixed()}°`}</span>
            </p>  
          </div> 
        </div>
        
    </div>
  )
}
